import { useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { toast } from "sonner";
import { Gift, Send, Loader2 } from "lucide-react";

export function SendCouponDialog({ phone, open, onClose, customerName }) {
  const { authAxios } = useAuth();
  const [couponCode, setCouponCode] = useState("");
  const [message, setMessage] = useState("");
  const [sending, setSending] = useState(false);

  const handleSend = async () => {
    if (!couponCode.trim()) { toast.error("Introduce el código del cupón"); return; }
    setSending(true);
    try {
      await authAxios.post(`/customers/${encodeURIComponent(phone)}/send-coupon`, { coupon_code: couponCode, message });
      toast.success("Cupón enviado por WhatsApp");
      onClose();
      setCouponCode("");
      setMessage("");
    } catch { toast.error("Error al enviar"); }
    setSending(false);
  };

  return (
    <Dialog open={open} onOpenChange={v => { if (!v) onClose(); }}>
      <DialogContent className="sm:max-w-md" data-testid="send-coupon-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Gift className="w-5 h-5 text-primary" /> Enviar Cupón a {customerName || phone}
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-4 py-2">
          <div>
            <Label className="text-sm mb-1.5 block">Código del Cupón *</Label>
            <Input value={couponCode} onChange={e => setCouponCode(e.target.value)} placeholder="ej. CLIENTE20" data-testid="coupon-code-input" />
          </div>
          <div>
            <Label className="text-sm mb-1.5 block">Mensaje personalizado (opcional)</Label>
            <Textarea value={message} onChange={e => setMessage(e.target.value)} placeholder="Dejar vacío para usar el mensaje predeterminado..." rows={4} data-testid="coupon-message-input" />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Cancelar</Button>
          <Button onClick={handleSend} disabled={sending} data-testid="send-coupon-confirm-btn">
            {sending ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : <Send className="w-4 h-4 mr-2" />} Enviar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
